const linkHelper = (href, external) => {
  let parsedHref = href;

  if (external && !href.includes('{openNewTab}')) {
    parsedHref += '{openNewTab}';
  }

  const metadata = {
    allowIcon: false,
    openNewTab: false,
    relative: false,
    scrollTo: false,
  };

  const customHooks = [];

  const metaSyntax = /(?:https?:\/\/)?{([^}]+)}/gi;

  parsedHref = parsedHref.replace(
    metaSyntax,
    (_match, meta) => {
      if (meta in metadata) {
        metadata[meta] = true;
      } else {
        customHooks.push(meta);
      }

      return '';
    },
  );

  const isLocationalHref = parsedHref.length > 0 && parsedHref !== '#';

  return {
    allowIcon: metadata.allowIcon,
    href: parsedHref,
    hooks: customHooks,
    openNewTab: isLocationalHref && metadata.openNewTab && !metadata.scrollTo,
    scrollTo: metadata.scrollTo,
    relative: metadata.relative,
  };
};

export default linkHelper;
